import React, { useState } from 'react';
import nukeIcon from './assets/nuclear.png';

const NukeButton = ({ onClick, limited = true }) => {
  const [hovered, setHovered] = useState(false);

  const nukeButton = {
    backgroundColor: '#49a7ab',
    borderRadius: '48px',
    color: 'white',
    border: 'none',
    float: 'right',
    padding: '6px 12px 6px 4px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: '14px',
    position: 'absolute',
    top: '4px',
    right: '6px',
    userSelect: 'none',
    zIndex: '9999',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    transition: 'width 0.3s ease',
    width: hovered ? '242px' : '32px', // expand on hover
    height: hovered ? 'auto' : '32px',
  };

  const iconStyle = {
    height: '24px',
    width: '24px',
    objectFit: 'contain',
    flexShrink: 0,
  };

  const textStyle = {
    marginLeft: '8px',
    opacity: hovered ? 1 : 0,
    transition: 'opacity 0.2s ease',
  };

  const handleClick = () => {

    // Normal destructive mode
    const confirmed = window.confirm("⚠️ Are you sure you want to revert all matches?");
    if (!confirmed) return;

    const input = prompt('Type "NUKE IT!" to proceed with resetting the project.');
    if (input !== 'NUKE IT!') {
      alert('❌ Action cancelled. You must type "NUKE IT!" exactly.');
      return;
    }

    if (onClick) onClick();
  };

  return (
    <button
      style={nukeButton}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={handleClick}
      type="button"
      title={'Resets all MATCHES back to their system detected values. This includes line items and zone designations.'}
    >
      <img src={nukeIcon} alt="Nuke Button" style={iconStyle} />
      <span style={textStyle}>
        {'RESET ENTIRE PROJECT'}
      </span>
    </button>
  );
};

export default NukeButton;
